module.exports = __webpack_public_path__ + "static/media/pdf.8a2403cf.png";